<template>
    <div class="train">
      <div class="banner">
        <img src="~imgs/train/banner.jpg" alt="">
      </div>
      <div class="title">
        培训专题
      </div>
      <div class="main container">
        <div class="item">
          <router-link to="/train-detail/1">
            <div class="content">
              <div class="left">
                <div class="title">
                  <div class="bar"></div><p>深圳知名品牌认定</p>
                </div>
                <span>2018年11月16日，在金政公司本部接待了深圳市知名品牌管理体系评审专家小组，在王灿林组长的带领下，三位评审专家开启了在金政一天的评审工作。</span>
              </div>
              <div class="right">
                <img src="~imgs/train/1.jpg" alt="" style="width: 600px;">
              </div>
            </div>
          </router-link>
          <router-link to="/train-detail/2">
            <div class="content">
              <div class="left">
                <div class="title">
                  <div class="bar"></div><p>贯标年审</p>
                </div>
                <span>为了评价我司现行知识产权管理体系运行的持续性和有效性，2019年1月18日，中知（北京）认证有限公司的专家莅临我司指导工作。</span>
              </div>
              <div class="right">
                <img src="~imgs/train/2.jpg" alt="" style="width: 600px;">
              </div>
            </div>
          </router-link>
          <router-link to="/train-detail/3">
            <div class="content">
              <div class="left">
                <div class="title">
                  <div class="bar"></div><p>中层管理者培训之《基于DISC语言行为风格的管理艺术》</p>
                </div>
                <span>为了不断提高金政公司管理人员的综合管理水平 ，提升中层管理人员识人、用人的能力，应各中层管理人员的需求，公司领导安排在2018年12月29日下午组织开展了一场《基于DISC语言行为风格的管理艺术》的课程，本次课程受训对象为中层管理人员及人力资源部成员，主要目的是提高受训人员在识人、用人、管理人员的能力。</span>
              </div>
              <div class="right">
                <img src="~imgs/train/3.jpg" alt="" style="width: 600px;">
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "index"
}
</script>

<style scoped>

</style>
